import { render, staticRenderFns } from "./ToTvs.container.vue?vue&type=template&id=6b27ad89&"
import script from "./ToTvs.container.vue?vue&type=script&lang=ts&"
export * from "./ToTvs.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports